import { get, post } from '../api.js';
import { hasKeys } from '../crypto.js';
import { navigate, currentParams } from '../router.js';
import { esc } from '../app.js';
import { getToken, setToken, setUserId, setEmail, setPostAuthRedirect, setPostAuthRedirectPersistent } from '../auth-store.js';

export async function renderGrantClaim(app, params) {
  const grantId = params.id;
  const { params: qp } = currentParams();
  const magicToken = qp.get('token');

  if (!grantId) {
    app.innerHTML = '<div class="msg msg-error">Invalid grant link</div>';
    return;
  }

  // Auto-authenticate if magic token is present (from email link)
  if (magicToken && !getToken()) {
    app.innerHTML = '<p class="loading">Signing in...</p>';
    try {
      const result = await post('/auth/magic-link/verify', { token: magicToken });
      setToken(result.token);
      if (result.user_id) setUserId(result.user_id);
      // Fetch email for sidebar display
      try {
        const me = await get('/auth/me');
        if (me.email) setEmail(me.email);
      } catch {}
    } catch (err) {
      app.innerHTML = `
        <div class="card" style="text-align:center">
          <div class="msg msg-error">Sign-in failed: ${esc(err.message)}</div>
          <p style="color:var(--text-dim);margin-top:1rem">The link may have expired. Request a new one by signing in.</p>
          <div class="actions" style="justify-content:center;margin-top:1rem">
            <a href="#/login" class="btn btn-primary">Sign In</a>
          </div>
        </div>`;
      return;
    }
  }

  const token = getToken();

  if (!token) {
    // Not authenticated — show email form
    renderSignInPrompt(app, grantId);
    return;
  }

  if (!hasKeys()) {
    // Authenticated but vault locked — redirect to unlock
    const redirect = `#/grants/${grantId}/access`;
    setPostAuthRedirectPersistent(redirect);
    try {
      const me = await get('/auth/me');
      const needsSetup = me.public_key.length <= 1;
      if (needsSetup) {
        navigate('#/setup-password');
      } else {
        navigate('#/unlock');
      }
    } catch {
      navigate('#/unlock');
    }
    return;
  }

  // Fully authenticated with keys — go straight to grant access
  navigate(`#/grants/${grantId}/access`);
}

function renderSignInPrompt(app, grantId) {
  const redirect = `#/grants/${grantId}/access`;
  setPostAuthRedirectPersistent(redirect);

  app.innerHTML = `
    <div class="card">
      <h1>Shared Item</h1>
      <p style="color:var(--text-dim);margin-bottom:1rem">
        Someone shared an encrypted item with you. Sign in to access it.
      </p>
      <div id="claim-msg"></div>
      <form id="claim-email-form">
        <label>Email <input type="email" name="email" required></label>
        <button type="submit" class="btn btn-primary">Send Magic Link</button>
      </form>
    </div>
  `;

  document.getElementById('claim-email-form').onsubmit = async (e) => {
    e.preventDefault();
    const msg = document.getElementById('claim-msg');
    const btn = e.target.querySelector('button');
    const email = e.target.email.value;
    btn.disabled = true;
    msg.innerHTML = '';

    try {
      await post('/auth/magic-link', { email });
      msg.innerHTML = `<div class="msg msg-success">Check your email for a magic link. After signing in, you'll be redirected to the shared item.</div>`;
      btn.style.display = 'none';
      e.target.querySelector('input').disabled = true;
    } catch (err) {
      msg.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
      btn.disabled = false;
    }
  };
}
